import { Directive, Input, TemplateRef } from '@angular/core';

/** Šablona záhlaví: `<ng-template appDataTableHeaderCell="columnId">` */
@Directive({
  selector: '[appDataTableHeaderCell]',
})
export class DataTableHeaderCellDirective {
  @Input('appDataTableHeaderCell') columnId!: string;

  constructor(public readonly templateRef: TemplateRef<unknown>) {}
}
